<div #gameContainer class="cards-container">
    <app-module-error *ngIf="somethingWentWrong && !isDataLoading"></app-module-error>
    <overlay-scrollbars [options]="currentView === 2 ? hiddenScrollOptions : scrollOptions" class="scrollbar mt-2">
        <div [hidden]="!noData" class="error-container">
            <svg class="error-icon">
                <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
            </svg>
            <p class="cxone-error-text" cvLocalizedText langSection="Games_Module" langKey="CXone_Data_Error">No data available</p>
        </div>
        <div [hidden]="noData" class="" container="body">
            <div *ngFor="let supervisor of supervisors">
                <cxone-agent-card [supervisor]="supervisor"></cxone-agent-card>
            </div>
        </div>
    </overlay-scrollbars>
</div>
